<template>
    <b-modal :ref="'modalconfirm'" :id="'modalconfirm'">
        <template slot="modal-header">
            <h2 class="mx-auto my-auto">{{ $t('modal.mouvement.suppression') }}</h2>
        </template>
        <template slot="default">
            <b>{{ $t('modal.mouvement.confirmation_suppression')}}</b>
            <br/>{{ $t('modal.general.avertissement_suppression') }}
            <br/>
            <br/><b-form-checkbox v-if="mvt && mvt.mouvement_type == 1" v-model="check">
                <b>{{ $t('modal.mouvement.desassociation') }}</b>
            </b-form-checkbox>
        </template>
        <template slot="modal-footer" class="justify-content-center">
            <b-button @click="closeModal" variant="primary" :disabled="processing">
                <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
                <font-awesome-icon v-else :icon="icon_accept" class="mr-1"/>
                {{ $t('global.supprimer') }}
            </b-button>
            <b-button @click="cancel" :disabled="processing">
                <font-awesome-icon :icon="['fal', 'times']" class="mr-1"/> {{ $t('global.annuler') }}
            </b-button>
        </template>
    </b-modal>
</template>

<script type="text/javascript">
    import Mouvements from "@/mixins/Mouvements.js"
    import Horse from "@/mixins/Horse.js"

	export default {
        name: "ModalConfirmDeleteMouvement",
        mixins: [
            Mouvements,
            Horse
        ],
        data () {
            return {
                icon: [],
                icon_accept: ["far", "trash-alt"],
                check: false,
                mvt: null,
                processing: false
            }
        },
        methods: {
            openModal(params) {
                this.mvt = params[0]
                this.check = false
                this.$bvModal.show('modalconfirm')
            },

            async closeModal() {
                if(this.processing) return
                
                this.processing = true
                
                try {
                    if(this.check && this.mvt.mouvement_type == 1) {
                        await this.updateHorseResidence(this.mvt.mouvement_horse, null)
                    }
                    
                    await this.applyDeleteMouvements([this.mvt])
                    this.$bvModal.hide('modalconfirm')
                    
                    // Émettre avec un flag indiquant si on a désassocié
                    this.$emit('submit', this.check)
                    
                    this.successToast('toast.info_suppression_succes')
                    
                } catch(error) {
                    console.error('Erreur lors de la suppression:', error)
                    this.failureToast('toast.error_suppression')
                } finally {
                    this.processing = false
                }
            },
            
            cancel(){
                this.check = false
                this.$bvModal.hide('modalconfirm')
            }
        }
	}
</script>